import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { actions as checkActions } from "reducers/checks";
import { actions as formActions } from "reducers/form";

export const useCheckbookTransaction = () => {
    const { id } = useParams();
    const { pathname, state = {} } = useLocation();

    const dispatch = useDispatch();
    const { transaction, fetching } = useSelector((_state) => _state.form);
    const isBackoffice = pathname.includes("backoffice");

    const { user } = useSelector((_state) => _state.session);

    const showSignButton = isEmpty(transaction?.signatures?.find((sign) => sign.idUser === user?.userId));

    useEffect(() => {
        if (id && isEmpty(state?.transaction)) {
            dispatch(formActions.readAgreementTransaction(id));
        }
    }, [id, dispatch]);

    useEffect(
        () => () => {
            dispatch(checkActions.cleanNewCheckbookTicket());
        },
        [],
    );

    return { isLoading: fetching, transaction, dispatch, showSignButton, id, isBackoffice };
};

export default useCheckbookTransaction;
